import { createFileRoute } from '@tanstack/react-router'
import {
  isMedicationIncidentKind,
  type MedicationIncidentKind,
} from '@workspace/utils/types/medication-incident'
import { requireActiveSubscription, requireAuth } from '@/lib/middleware'
import { KindReportPage } from '@/features/incidents/medication-report/kind-report-page'

// `medications_` de-nests this page from the Medications tab, which renders no <Outlet />
// (the lesson of a083457d6). URL: /clients/$clientId/medications/report. The search declares
// keys only: the kind, and the dose record or the medicine the kind starts from (MI-4). The
// API decides who may report; the page shows the supervisor handoff when the answer is no.
function uuidKey(value: unknown): string | undefined {
  return typeof value === 'string' && /^[0-9a-f-]{36}$/i.test(value)
    ? value
    : undefined
}

export const Route = createFileRoute(
  '/_authenticated/_organization/clients/$clientId/medications_/report'
)({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    kind?: MedicationIncidentKind
    administrationRecordId?: string
    medicationId?: string
  } => ({
    kind: isMedicationIncidentKind(search.kind) ? search.kind : undefined,
    administrationRecordId: uuidKey(search.administrationRecordId),
    medicationId: uuidKey(search.medicationId),
  }),
  beforeLoad: async () => {
    await requireAuth()
    await requireActiveSubscription()
  },
  component: KindReportPage,
})
